import { call, takeLatest } from "redux-saga/effects";
import {
    getRegionalRestrictionsListApi,
    getStoreListApi,
    getItemsListApi,
    addRegionalRestrictionApi,
    getCategoriesApi,
    getItemTypesApi,
    getItemGroupsApi,
    getManufacturersApi,
    getItemsByStoreIdApi,
    getRestrictionByItemIdApi,
    getRegionalRestrictionsItemListApi,
} from "../apis/regional-restrictions-api";
import {
    REGIONAL_RESTRICTION_LIST,
    REGIONAL_RESTRICTION_STORE_LIST,
    REGIONAL_RESTRICTION_ITEMS_LIST,
    REGIONAL_RESTRICTION_ADD,
    REGIONAL_RESTRICTION_CATEGORIES,
    REGIONAL_RESTRICTION_TYPES,
    REGIONAL_RESTRICTION_GROUPS,
    REGIONAL_RESTRICTION_MANUFACTURERS,
    REGIONAL_RESTRICTION_ITEMS_BY_STORE,
    REGIONAL_RESTRICTION_BY_ITEM_ID,
    REGIONAL_RESTRICTION_ITEM_LIST,
} from "../types";

export function* getRegionalRestrictionsListWorker(action) {
    try {
        const res = yield call(getRegionalRestrictionsListApi, action.data);
        if (res.data?.code === 200) {
            yield action.onSuccess(res.data);
        } else {
            yield action.onError(res?.data);
        }
    } catch (error) {
        yield action.onError(error?.response);
    }
}

export function* getRegionalRestrictionsItemListWorker(action) {
    try {
        const res = yield call(getRegionalRestrictionsItemListApi, action.data);
        if (res.data?.code === 200) {
            yield action.onSuccess(res.data);
        } else {
            yield action.onError(res?.data);
        }
    } catch (error) {
        yield action.onError(error?.response);
    }
}

export function* getStoreListWorker(action) {
    try {
        const res = yield call(getStoreListApi);
        if (res.data?.code === 200) {
            yield action.onSuccess(res.data);
        } else {
            yield action.onError(res?.data);
        }
    } catch (error) {
        yield action.onError(error?.response);
    }
}

export function* getItemsListWorker(action) {
    try {
        const res = yield call(getItemsListApi, action.data);
        if (res.data?.code === 200) {
            yield action.onSuccess(res.data);
        } else {
            yield action.onError(res?.data);
        }
    } catch (error) {
        yield action.onError(error?.response);
    }
}

export function* addRegionalRestrictionWorker(action) {
    try {
        const res = yield call(addRegionalRestrictionApi, action.data);
        if (res.data?.code === 200) {
            yield action.onSuccess(res.data);
        } else {
            yield action.onError(res?.data);
        }
    } catch (error) {
        yield action.onError(error?.response);
    }
}

// Dropdown filter workers
export function* getCategoriesWorker(action) {
    try {
        const res = yield call(getCategoriesApi);
        if (res.data?.code === 200 || res.status === 200) {
            yield action.onSuccess(res.data);
        } else {
            yield action.onError(res?.data);
        }
    } catch (error) {
        yield action.onError(error?.response);
    }
}

export function* getItemTypesWorker(action) {
    try {
        const res = yield call(getItemTypesApi);
        if (res.data?.code === 200 || res.status === 200) {
            yield action.onSuccess(res.data);
        } else {
            yield action.onError(res?.data);
        }
    } catch (error) {
        yield action.onError(error?.response);
    }
}

export function* getItemGroupsWorker(action) {
    try {
        const res = yield call(getItemGroupsApi);
        if (res.data?.code === 200 || res.status === 200) {
            yield action.onSuccess(res.data);
        } else {
            yield action.onError(res?.data);
        }
    } catch (error) {
        yield action.onError(error?.response);
    }
}

export function* getManufacturersWorker(action) {
    try {
        const res = yield call(getManufacturersApi);
        if (res.data?.code === 200 || res.status === 200) {
            yield action.onSuccess(res.data);
        } else {
            yield action.onError(res?.data);
        }
    } catch (error) {
        yield action.onError(error?.response);
    }
}

// Sub-table saga workers
export function* getItemsByStoreIdWorker(action) {
    try {
        const res = yield call(getItemsByStoreIdApi, action.storeId);
        if (res.data?.code === 200) {
            yield action.onSuccess(res.data);
        } else {
            yield action.onError(res?.data);
        }
    } catch (error) {
        yield action.onError(error?.response);
    }
}

export function* getRestrictionByItemIdWorker(action) {
    try {
        const res = yield call(getRestrictionByItemIdApi, action.itemId, action.storeId);
        if (res.data?.code === 200) {
            yield action.onSuccess(res.data);
        } else {
            yield action.onError(res?.data);
        }
    } catch (error) {
        yield action.onError(error?.response);
    }
}

export default function* regionalRestrictionsSaga() {
    yield takeLatest(REGIONAL_RESTRICTION_LIST, getRegionalRestrictionsListWorker);
    yield takeLatest(REGIONAL_RESTRICTION_ITEM_LIST, getRegionalRestrictionsItemListWorker);
    yield takeLatest(REGIONAL_RESTRICTION_STORE_LIST, getStoreListWorker);
    yield takeLatest(REGIONAL_RESTRICTION_ITEMS_LIST, getItemsListWorker);
    yield takeLatest(REGIONAL_RESTRICTION_ADD, addRegionalRestrictionWorker);
    yield takeLatest(REGIONAL_RESTRICTION_CATEGORIES, getCategoriesWorker);
    yield takeLatest(REGIONAL_RESTRICTION_TYPES, getItemTypesWorker);
    yield takeLatest(REGIONAL_RESTRICTION_GROUPS, getItemGroupsWorker);
    yield takeLatest(REGIONAL_RESTRICTION_MANUFACTURERS, getManufacturersWorker);
    yield takeLatest(REGIONAL_RESTRICTION_ITEMS_BY_STORE, getItemsByStoreIdWorker);
    yield takeLatest(REGIONAL_RESTRICTION_BY_ITEM_ID, getRestrictionByItemIdWorker);
}
